/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type EventManagementReceptRequest = {
    perPage?: number | null;
    page?: number | null;
    keyword?: string | null;
    sort?: string | null;
    direction?: EventManagementReceptRequest.direction | null;
    eventNumber?: number;
    memberId?: number;
    fullName?: string;
    tel?: string;
};

export namespace EventManagementReceptRequest {

    export enum direction {
        ASC = 'asc',
        DESC = 'desc',
    }


}

